import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M11 5L22 12L11 19L11 12.75L2 12.75L2 11.25L11 11.25L11 5Z" fill="black"/>
    </svg>
)
